import React, { useEffect, useState } from "react";
import axios from "axios";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

export default function OrderSummary() {
  const { cart } = useCart();
  const navigate = useNavigate();
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  const [shippingInfo, setShippingInfo] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem("shippingInfo");
    if (!saved) {
      navigate("/checkout");
      return;
    }
    setShippingInfo(JSON.parse(saved));
  }, [navigate]);

  if (!shippingInfo) return null;

  const HST_RATE = 0.13;
  const subtotal = cart.reduce((sum, item) => sum + item.price * item.qty, 0);
  const tax = subtotal * HST_RATE;
  const total = subtotal + tax;

  const handleCheckout = async () => {
    try {
      console.log("🛒 Sending checkout payload:", {
        items: cart,
        shipping: shippingInfo,
      });

      const res = await axios.post(
        `${API_BASE}/api/orders/create-checkout`,
        {
          items: cart,
          shippingInfo,
        },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      console.log("🧾 Checkout response:", res.data);

      if (res.data?.url) {
        window.location.href = res.data.url; // Stripe redirect
      } else {
        alert(res.data?.error || "Checkout session failed.");
      }

    } catch (err) {
      console.error("❌ Checkout Error:", err);
      alert("Something went wrong. Try again.");
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Order Summary</h1>

      <div className="bg-white shadow p-6 rounded-xl">
        <h2 className="text-xl font-semibold mb-4">Items</h2>

        {cart.map((item) => (
          <div key={item._id} className="flex justify-between border-b py-3">
            <div>
              <p className="font-semibold">{item.name}</p>
              <p className="text-sm text-gray-500">
                Qty: {item.qty} × ${item.price}
              </p>
            </div>
            <p className="font-semibold">
              ${(item.price * item.qty).toFixed(2)}
            </p>
          </div>
        ))}

        <div className="mt-6">
          <h2 className="text-xl font-semibold mb-2">Shipping Info</h2>
          <p className="text-gray-700">
            {shippingInfo.name}<br />
            {shippingInfo.address}<br />
            {shippingInfo.city} {shippingInfo.zip}<br />
            {shippingInfo.email}<br />
            {shippingInfo.phone}
          </p>
        </div>

        <div className="mt-6 space-y-2 text-gray-800">
          <div className="flex justify-between">
            <span>Subtotal</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>

          <div className="flex justify-between">
            <span>Shipping</span>
            <span>Free</span>
          </div>

          <div className="flex justify-between text-sm text-gray-600 italic">
            <span>Tax</span>
            <span>Calculated at checkout</span>
          </div>

          <div className="flex justify-between text-xl font-bold mt-3 pt-3 border-t">
            <span>Total</span>
            <span>${total.toFixed(2)}</span>
          </div>
        </div>

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate("/checkout")}
            className="flex-1 bg-gray-200 py-3 rounded-lg hover:bg-gray-300"
          >
            Edit Address
          </button>

          <button
            onClick={handleCheckout}
            className="flex-1 bg-black text-white py-3 rounded-lg hover:bg-gray-800"
          >
            Proceed to Payment
          </button>
        </div>
      </div>
    </div>
  );
}
